import React from "react"
import { StyleSheet, View } from "react-native"
import { CustomText } from "../../../components/text/Text"
import { useTranslation } from "react-i18next"
import SVG from "../../../imports/svg"

const Decription=()=>{
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <View style={styles.textRow}>
                <CustomText mr={8} size={14} font={'400'}>
                    {t('please_pay_your_debt')}
                </CustomText>
                <SVG  name={'grayInfo'} width={20} height={20}/>
            </View>
        </View>
    )
}
export default Decription

const styles = StyleSheet.create({
    container : {
        width : '100%' , 
        backgroundColor : '#F7F7F7' , 
        borderRadius : 18 , 
        padding : 12 , 
        borderWidth : 1 , 
        borderColor : '#EAEAEA' , 

    },
    textRow : {
        flexDirection : 'row' , 
        alignSelf : 'flex-end' , 
    }
})